import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { signIn, type SignInParams } from './auth-api'
import { useAuthStore } from '../stores/use-auth-store'
import { supabase } from '@/lib/supabase/client'

export function useSignInMutation() {
  const setUser = useAuthStore((s) => s.setUser)
  const navigate = useNavigate()

  return useMutation({
    mutationFn: (params: SignInParams) => signIn(params),
    onSuccess: async (data) => {
      const session = data.session
      if (!session?.user) return

      const userId = session.user.id

      // Load user profile for name + super user flag
      const { data: profile } = await supabase
        .from('user_profiles')
        .select('full_name, is_super_user')
        .eq('id', userId)
        .maybeSingle()

      setUser({
        id: userId,
        email: session.user.email ?? '',
        name: profile?.full_name ?? session.user.user_metadata?.full_name ?? undefined,
        isSuperUser: profile?.is_super_user ?? false,
      })

      // Check project memberships — if none, send to W04
      const { count } = await supabase
        .from('project_memberships')
        .select('id', { count: 'exact', head: true })
        .eq('user_id', userId)
        .eq('is_removed', false)

      if ((count ?? 0) === 0 && !profile?.is_super_user) {
        navigate('/no-projects')
      } else {
        navigate('/projects')
      }
    },
  })
}
